<template lang="pug">

  v-dialog(ref="subscribeModal" v-model="show" max-width="500px")

    .dialogHeader

      .dialogHeaderTitle {{ titulo }}

      .dialogHeaderClose
        .dialogCloseButton.mdi.mdi-close(@click="close()")

    .dialogBody

      .dialogBodyContent

        .textModal.text-center.mb-3(v-html="text")

        .mt-3.text-center

          sos-button(@buttonClick="goToPlanos()" size="medium" buttonLabel="Conheça nossos planos" buttonIconSize="16" color="success")

</template>

<script>
  import SosButton from '@/components/SosButton'

  export default {
    name: 'SubscriptionModal',

    components: {
      'sos-button': SosButton,
    },

    props: {
      active: {
        type: Boolean,
        required: true,
      },
      titulo: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
    },

    data: function () {
      return {
        show: false, // this.active,
      }
    },
    watch: {
      show: {
        immediate: true,
        handler: function (newShow, oldShow) {
          const closing = oldShow === true && newShow === false
          if (closing) {
            // [24/01/25] console.log('[closing]')
            this.show = false
            this.$emit('close', false)
          }
        },
      },
      active: {
        immediate: true,
        handler: function (newActive, oldActive) {
          const opening = newActive === true
          if (opening) {
            // [24/01/25] console.log('[opening]')
            this.show = true
          }
        },
      },
    },
    methods: {
      close: function () {
        this.show = false
        this.$emit('close', false)
      },
      goToPlanos () {
        this.$router.push('/admin/assinatura')
      },
    },
  }
</script>

<style lang="sass">
  .textModal
    font-size: 18px
    line-height: 30px
</style>
